import React from 'react';

export type ReportIssueIframeProps = {
  src: string;
};

/**
 * Renders the report-issue form in a iframe.
 *
 * Prefill data is passed through the URL query parameters. The iframe is
 * checked for reachability before it is mounted by useReportIssue.
 *
 * The component does not handle iframe load failures because cross-origin
 * errors cannot be reliably detected from the parent application.
 */
export const ReportIssueIframe: React.FC<ReportIssueIframeProps> = ({
  src,
}) => (
  <div className="relative h-full min-h-0 w-full p-2">
    <iframe
      title="Report an issue"
      src={src}
      className="h-full w-full"
      data-testid="reportIssueIframe"
    />
  </div>
);